<template>
  <section id="link-navidad-section" class="navidad-section">
    <div class="container">
      <div class="navidad-card">
        <!-- Título solo en modo responsive (< 992px) -->
        <div class="navidad-mobile-header text-center">
          <h2 class="navidad-title font-1">
            {{ navidadData.title }}
          </h2>
        </div>

        <div class="row align-items-center justify-content-center g-4">
          <!-- Columna Imagen / Flyer interactivo -->
          <div class="col-lg-5 col-md-12 text-center">
            <div class="flyer-wrapper" @click="openModal">
              <img :src="flyerImage" :alt="navidadData.title" class="flyer-img img-fluid" />
              <div class="flyer-overlay">
                <span class="zoom-btn">
                  <i class="fas fa-search-plus mr-1"></i> {{ navidadData.viewFlyer }}
                </span>
              </div>
              <div class="badge-ribbon">
                <span>2026</span>
              </div>
            </div>
          </div>

          <!-- Columna Información y Reservas (solo visible en escritorio >= 992px) -->
          <div class="col-lg-7 col-md-12 navidad-desktop-content">
            <div class="navidad-content">
              <div class="badge-pill mb-2">
                <i class="fas fa-holly-berry mr-1"></i> {{ navidadData.badge }}
              </div>

              <h2 class="navidad-title font-1">
                {{ navidadData.title }}
              </h2>

              <p class="navidad-subtitle font-2">
                {{ navidadData.subtitle }}
              </p>

              <!-- Tarjetas de Precios -->
              <div class="price-cards-row">
                <div class="price-card primary">
                  <div class="price-badge">{{ navidadData.adultPrice }}</div>
                  <div class="price-desc">{{ navidadData.adultPriceSub }}</div>
                </div>
                <div class="price-card secondary">
                  <div class="price-badge">{{ navidadData.kidsPrice }}</div>
                  <div class="price-desc">{{ navidadData.kidsPriceSub }}</div>
                </div>
              </div>

              <!-- Lista de platos destacados -->
              <ul class="navidad-features font-2">
                <li v-for="(feature, idx) in navidadData.features" :key="idx">
                  <i class="fas fa-star feature-icon"></i>
                  <span>{{ feature }}</span>
                </li>
              </ul>

              <!-- Botones de Acción / Reserva -->
              <div class="navidad-actions">
                <a :href="whatsappUrl" target="_blank" rel="noopener noreferrer" class="btn btn-navidad-whatsapp">
                  <i class="fab fa-whatsapp mr-2"></i> {{ navidadData.whatsappLabel }}
                </a>
                <a :href="'tel:' + navidadData.phone" class="btn btn-navidad-phone">
                  <i class="fas fa-phone-alt mr-2"></i> {{ navidadData.phoneLabel }}
                </a>
                <button type="button" class="btn btn-navidad-flyer" @click="openModal">
                  <i class="fas fa-book-open mr-2"></i> {{ navidadData.viewFlyer }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Lightbox para ampliar el folleto -->
    <div v-if="isModalOpen" class="navidad-modal-backdrop" @click.self="closeModal">
      <div class="navidad-modal-content">
        <button type="button" class="navidad-modal-close" @click="closeModal" :aria-label="navidadData.close">
          &times;
        </button>
        <div class="navidad-modal-body">
          <img :src="flyerImage" :alt="navidadData.title" class="navidad-modal-img" />
        </div>
        <div class="navidad-modal-footer">
          <a :href="flyerImage" target="_blank" class="btn btn-outline-light btn-sm">
            <i class="fas fa-external-link-alt mr-1"></i> {{ navidadData.viewFlyer }}
          </a>
          <button type="button" class="btn btn-secondary btn-sm ml-2" @click="closeModal">
            {{ navidadData.close }}
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "NavidadSection",
  data() {
    return {
      isModalOpen: false,
    };
  },
  computed: {
    navidadData() {
      const data = this.$store.getters.currentData;
      return (
        data.navidadSection || {
          badge: "Especial Navidad 2026",
          title: "Menú Especial de Navidad y San Esteban",
          subtitle: "Celebra con nosotros en Casa Muyo",
          adultPrice: "56€",
          adultPriceSub: "por persona (Todo Incluido)",
          kidsPrice: "35€",
          kidsPriceSub: "Menú Infantil",
          features: [],
          phone: "932317716",
          phoneLabel: "Llamar: 932 31 77 16",
          whatsapp: "+34631810727",
          whatsappLabel: "Reservar por WhatsApp",
          whatsappMessage: "¡Hola! Me gustaría reservar mesa para el Menú de Navidad 2026.",
          viewFlyer: "Ver Folleto Completo",
          close: "Cerrar",
        }
      );
    },
    flyerImage() {
      try {
        return require("../../assets/img/menu/menu-navidad.jpeg");
      } catch (e) {
        return "";
      }
    },
    whatsappUrl() {
      const cleanPhone = (this.navidadData.whatsapp || "34631810727").replace(/\D/g, "");
      const msg = encodeURIComponent(
        this.navidadData.whatsappMessage ||
        "Hola! Me gustaría reservar mesa para el Menú de Navidad 2026."
      );
      return `https://wa.me/${cleanPhone}?text=${msg}`;
    },
  },
  methods: {
    openModal() {
      this.isModalOpen = true;
      document.body.style.overflow = "hidden";
    },
    closeModal() {
      this.isModalOpen = false;
      document.body.style.overflow = "";
    },
  },
  beforeUnmount() {
    document.body.style.overflow = "";
  },
};
</script>

<style scoped>
.navidad-section {
  padding: 3.5rem 0 2.5rem 0;
  background: linear-gradient(180deg, #f7f3eb 0%, #ffffff 100%);
}

.navidad-card {
  background: linear-gradient(135deg, #440c17 0%, #29050d 100%);
  border: 2px solid #d4af37;
  border-radius: 18px;
  padding: 2.5rem;
  color: #fdfaf2;
  box-shadow: 0 16px 36px rgba(68, 12, 23, 0.28);
  position: relative;
  overflow: hidden;
}

.navidad-card::before {
  content: "";
  position: absolute;
  top: -60px;
  right: -60px;
  width: 180px;
  height: 180px;
  background: radial-gradient(circle, rgba(212, 175, 55, 0.25) 0%, transparent 70%);
  pointer-events: none;
}

/* Flyer Image Wrapper */
.flyer-wrapper {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  border: 3px solid #d4af37;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.45);
  max-width: 380px;
  margin: 0 auto;
}

.flyer-wrapper:hover {
  transform: translateY(-4px) scale(1.02);
  box-shadow: 0 14px 32px rgba(212, 175, 55, 0.35);
}

.flyer-img {
  width: 100%;
  height: auto;
  display: block;
}

.flyer-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.85), transparent);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0.95;
  transition: opacity 0.3s ease;
}

.flyer-wrapper:hover .flyer-overlay {
  opacity: 1;
}

.zoom-btn {
  background: rgba(212, 175, 55, 0.9);
  color: #29050d;
  font-weight: bold;
  font-size: 0.9rem;
  padding: 6px 14px;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.badge-ribbon {
  position: absolute;
  top: 10px;
  right: -30px;
  background: #d4af37;
  color: #29050d;
  padding: 4px 35px;
  font-weight: 800;
  font-size: 0.85rem;
  transform: rotate(45deg);
  letter-spacing: 1px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}

/* Contenido */
.navidad-content {
  padding-left: 1rem;
}

.badge-pill {
  display: inline-block;
  background: rgba(212, 175, 55, 0.2);
  border: 1px solid #d4af37;
  color: #f7d67b;
  font-size: 0.85rem;
  font-weight: 700;
  padding: 5px 14px;
  border-radius: 20px;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.navidad-title {
  font-size: 2.2rem;
  color: #ffffff;
  margin: 0.5rem 0;
  line-height: 1.25;
  text-shadow: 1px 2px 4px rgba(0, 0, 0, 0.5);
}

.navidad-subtitle {
  font-size: 1.05rem;
  color: #eedcc0;
  margin-bottom: 1.5rem;
  line-height: 1.5;
}

/* Tarjetas de Precios */
.price-cards-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
}

.price-card {
  padding: 0.75rem 1.4rem;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}

.price-card.primary {
  background: rgba(212, 175, 55, 0.18);
  border: 1px solid #d4af37;
}

.price-card.primary .price-badge {
  font-size: 2rem;
  font-weight: 800;
  color: #f7d67b;
  line-height: 1;
}

.price-card.primary .price-desc {
  font-size: 0.85rem;
  color: #eedcc0;
  margin-top: 4px;
}

.price-card.secondary {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.price-card.secondary .price-badge {
  font-size: 1.6rem;
  font-weight: 700;
  color: #ffffff;
  line-height: 1;
}

.price-card.secondary .price-desc {
  font-size: 0.85rem;
  color: #cccccc;
  margin-top: 4px;
}

/* Lista de Platos */
.navidad-features {
  padding: 0;
  margin: 0 0 1.8rem 0;
  list-style: none;
}

.navidad-features li {
  display: flex;
  align-items: flex-start;
  margin-bottom: 0.55rem;
  font-size: 0.95rem;
  color: #f3ede2;
  line-height: 1.4;
}

.feature-icon {
  color: #d4af37;
  font-size: 0.8rem;
  margin-right: 0.75rem;
  margin-top: 0.25rem;
}

/* Botones de Acción */
.navidad-actions {
  display: flex;
  gap: 0.85rem;
  flex-wrap: wrap;
}

/* Botón principal (WhatsApp) - Oro elegante y destacado */
.btn-navidad-whatsapp {
  background: linear-gradient(135deg, #e5c358 0%, #c49a2c 100%);
  color: #29050d !important;
  font-weight: 700;
  font-size: 0.95rem;
  padding: 10px 20px;
  border-radius: 8px;
  border: 1px solid #e5c358;
  transition: all 0.25s ease;
  display: inline-flex;
  align-items: center;
  box-shadow: 0 4px 14px rgba(212, 175, 55, 0.35);
}

.btn-navidad-whatsapp:hover {
  background: linear-gradient(135deg, #f0d06b 0%, #d4a938 100%);
  transform: translateY(-2px);
  color: #29050d !important;
  box-shadow: 0 6px 18px rgba(212, 175, 55, 0.5);
}

/* Botón secundario (Llamar) - Cristal oscuro refinado con borde dorado */
.btn-navidad-phone {
  background-color: rgba(212, 175, 55, 0.1);
  color: #fdfaf2 !important;
  font-weight: 600;
  font-size: 0.95rem;
  padding: 10px 20px;
  border-radius: 8px;
  border: 1px solid rgba(212, 175, 55, 0.6);
  transition: all 0.25s ease;
  display: inline-flex;
  align-items: center;
  backdrop-filter: blur(4px);
}

.btn-navidad-phone:hover {
  background-color: rgba(212, 175, 55, 0.22);
  border-color: #d4af37;
  transform: translateY(-2px);
  color: #ffffff !important;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.3);
}

.btn-navidad-phone i {
  color: #f7d67b;
}

/* Botón terciario (Ver Folleto) - Outline minimalista y elegante */
.btn-navidad-flyer {
  background-color: rgba(255, 255, 255, 0.05);
  color: #eedcc0 !important;
  border: 1px solid rgba(255, 255, 255, 0.25);
  font-weight: 600;
  font-size: 0.95rem;
  padding: 10px 20px;
  border-radius: 8px;
  transition: all 0.25s ease;
  display: inline-flex;
  align-items: center;
  backdrop-filter: blur(4px);
}

.btn-navidad-flyer:hover {
  background-color: rgba(212, 175, 55, 0.15);
  border-color: rgba(212, 175, 55, 0.7);
  color: #ffffff !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.3);
}

.btn-navidad-flyer i {
  color: #f7d67b;
}

/* Modal Lightbox */
.navidad-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.88);
  z-index: 1050;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.5rem;
  animation: fadeIn 0.25s ease;
}

.navidad-modal-content {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.navidad-modal-close {
  position: absolute;
  top: -45px;
  right: -10px;
  background: transparent;
  border: none;
  color: #ffffff;
  font-size: 2.5rem;
  line-height: 1;
  cursor: pointer;
  padding: 0 10px;
  z-index: 1055;
  transition: color 0.2s ease;
}

.navidad-modal-close:hover {
  color: #d4af37;
}

.navidad-modal-body {
  max-height: 75vh;
  overflow: auto;
  border-radius: 8px;
  border: 2px solid #d4af37;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.7);
}

.navidad-modal-img {
  max-height: 75vh;
  max-width: 100%;
  display: block;
  object-fit: contain;
}

.navidad-modal-footer {
  margin-top: 1rem;
  display: flex;
  justify-content: center;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

/* Responsive */
.navidad-mobile-header {
  display: none;
}

.navidad-desktop-content {
  display: block;
}

@media (max-width: 991px) {
  .navidad-mobile-header {
    display: block;
    margin-bottom: 1.5rem;
  }

  .navidad-desktop-content {
    display: none !important;
  }

  .navidad-card {
    padding: 1.8rem;
  }

  .navidad-title {
    font-size: 1.8rem;
  }
}

@media (max-width: 576px) {
  .navidad-section {
    padding: 2rem 0;
  }

  .navidad-card {
    padding: 1.25rem;
  }

  .navidad-title {
    font-size: 1.5rem;
  }

  .navidad-mobile-header {
    margin-bottom: 1.2rem;
  }
}
</style>
